import React, { useContext, useEffect, useState } from "react";
import FirstVendor from "./FirstVendor/FirstVendor";
import SecondVendor from "./SecondVendor/SecondVendor";
import RateAndReview from "./RateAndReview/RateAndReview";

import { useLocation, useNavigate, useParams } from "react-router-dom";
import { getProductDetail } from "../../utils/apis/Product/Product";
import { getCartCheck } from "../../utils/apis/addToCart/addToCart";
import { Context } from "../../utils/context";
import Cookies from "js-cookie";
const VendorPage = () => {
  useEffect(() => {
    window.scrollTo(0, 0);
  }, []);
  const { signin, variant, subvariant } = useContext(Context);

  const navigate = useNavigate();
  const [product, setProduct] = useState();
  const [cartStatus, setCartStatus] = useState(false);
  const [cartData, setCartData] = useState();
  const [variantId, setVariantId] = useState("");

  const { id } = useParams();

  const getProduct = async () => {
    if (id) {
      const res = await getProductDetail(id);

      if (res?.success) {
        await setProduct(res?.data);
        var response;

        if (Cookies.get("silk_security")) {
          const data = {
            product_id: id,
            variant_id: variant?.id,
            m_variant_id: subvariant?.id,
          };

          response = await getCartCheck(data);
        } else {
          const data = {
            product_id: id,
            variant_id: variant?.id,
            m_variant_id: subvariant?.id,
          };
          response = await getCartCheck(data);
        }
        if (response?.success) {
          if (
            response?.cartItem?.variant_id == variant?.id ||
            response?.cartItem?.m_variant_id == subvariant?.id
          ) {
            await setCartStatus(true);
          } else {
            await setCartStatus(false);
          }
          await setCartData(response?.cartItem);
        }
      }
    } else {
      navigate("/");
    }
  };

  // useEffect(() => {
  //   window.scrollTo({
  //     top: 0,
  //     behavior: "smooth",
  //   });
  // });

  useEffect(() => {
    getProduct();
  }, [id]);

  return (
    <>
      <FirstVendor
        product={product}
        cartStatus={cartStatus}
        setCartStatus={setCartStatus}
        cartData={cartData}
        getProduct={getProduct}
        setVariantId={setVariantId}
        setCartData={setCartData}
      />
      {/* <RateAndReview product={product} /> */}
      <SecondVendor heading="You may also like" product={product} />
    </>
  );
};

export default VendorPage;
